import { Link, useNavigate, useParams } from 'react-router-dom'
import { api } from '@/api/client'
import { useAsync } from '@/components/useAsync'
import { Picker } from '@/components/Picker'
import { ReviewPanel } from '@/components/reviews/ReviewPanel'
import type { ReviewHistory } from '@/components/reviews/types'
import { fmtDate } from '@/lib/format'

const statuses: Record<string, string> = {
  open: 'In review', deciding: 'Submitting', approved: 'Approved', returned: 'Changes requested',
  superseded: 'Previous submission', published: 'Published', preparing: 'Preparing',
}

export default function Review() {
  const { taskId = '', roundId = '' } = useParams()
  const navigate = useNavigate()
  const history = useAsync(() => api.get<ReviewHistory>(`/tasks/${taskId}/reviews`), [taskId, roundId])
  const kind = history.data?.rounds.find(round => round.round_id === roundId)?.kind
  const rounds = history.data?.rounds.filter(round => round.kind === kind) ?? []
  const options = rounds.map((round, index) => ({
    value: round.round_id,
    label: round.round_id === history.data?.current_round_id ? 'Current review' : `Review ${rounds.length - index}`,
    detail: `${fmtDate(round.created_at)} · ${statuses[round.status] ?? round.status}`,
  }))
  return (
    <div>
      <Link className="backlink" to="/sme/reviews?mine=1">← Reviews</Link>
      {history.error && <p className="small muted">Review history could not load. <button className="link small" onClick={history.reload}>Retry</button></p>}
      <ReviewPanel key={`${taskId}:${roundId}`} taskId={taskId} roundId={roundId} role="sme" standalone
        reviewPicker={options.length > 1 ? <Picker label="Review history" value={roundId} options={options}
          onChange={value => navigate(`/sme/reviews/${taskId}/${value}`)} /> : undefined} />
    </div>
  )
}
